import React, { Component } from 'react';
import '../myutils';
import {
    SelectInput,
    SimpleForm,
    TextInput,
    translate,
    FormDataConsumer
} from 'react-admin';
import Paper from '@material-ui/core/Paper';
import BookIcon from '@material-ui/icons/Book';
import Button from '@material-ui/core/Button';
import Sms from '@material-ui/icons/Sms';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { ReactMic } from '@cleandersonlobo/react-mic';
import MicrophoneOn from '@material-ui/icons/Mic';
import MicrophoneOff from '@material-ui/icons/MicOff';
import { configAPI } from '../config'
import DropzoneComponent from 'react-dropzone';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Typography } from '@material-ui/core';
export const TemplateIcon = BookIcon;

class QuickSendButton extends Component {

    state = {
        open: false,
    };
    constructor(props) {
        super(props);
        this.state = {
            record: false
        }

    }

    startRecording = () => {
        this.setState({
            record: true
        });
    }

    stopRecording = () => {
        this.setState({
            record: false
        });
    }

    onData(recordedBlob) {
        console.log('chunk of real-time data is: ', recordedBlob);
    }

    onStop = (recordedBlob) => {
        console.log('recordedBlob is: ', recordedBlob.blob);
        this.setState({
            newRecording: recordedBlob.blob
        })
    }
    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleMessageChange = (e) => {
        this.setState({ message: e.target.value });
    };

    handleMessageTypeChange = (e) => {
        this.setState({ messageType: e[0] });
    };

    handleReceiverChange = (e) => {
        let recepient = e.target.value;
        recepient = recepient.replace(/\s/g, '');
        recepient = recepient.replace(/,/g, ':');
        this.setState({ receiver: recepient });
    };

    handleFileChange = (e) => {
        console.log(e[0].rawFile);
        this.setState({ selectedFile: e[0].rawFile })
    };

    onDrop = (files) => {
        // POST to a test endpoint for demo purposes
        this.setState({ selectedFile: files[files.length - 1] })
        console.log(files[files.length - 1])
    }

    handleSendSubmit = () => {
        var data = new FormData();
        const { message, receiver, messageType } = this.state;
        if (messageType === 'T' || messageType === 'A' || messageType === 'R' || messageType === 'S') {
            const createReq = new Request(configAPI.api.prod + 'CreateTemplate?token=' + sessionStorage.B.encodeDecode())
            return fetch(createReq)
                .then(resp => { return resp.json(); })
                .then(createResp => {
                    let templateId = createResp.templateId;
                    switch (messageType) {
                        case 'S':
                        case 'T':
                        {
                            let newReceiver = '"' + receiver;
                            let phoneExpression = newReceiver.replace(/:/g, '":"' + message + '","');
                            phoneExpression = phoneExpression + '":"' + message + '"';
                            const request = new Request(configAPI.api.prod + 'RunCampaign?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + templateId + '&ttsMode=1&phones={' + phoneExpression + '}&withSMS=' + (messageType === 'S'))
                            return fetch(request)
                                .then(resp => { return resp.json(); })
                                .then(responseRun => {
                                    console.log(responseRun);
                                    if (responseRun.responseStatus === 'OK') {
                                        this.setState({
                                            blocked: responseRun.blocked, pending: responseRun.pending, customerUnits: responseRun.customerUnits,
                                            estimatedPrice: responseRun.estimatedPrice, entriesCount: responseRun.entriesCount
                                        })
                                        const request = new Request(configAPI.api.prod + 'DeleteTemplate?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + templateId)
                                        return fetch(request)
                                            .then(responseDelete => {
                                                console.log(responseDelete);
                                            })
                                    }
                                })
                        }
                        case 'A': {
                            data.append("upload", this.state.selectedFile);
                            data.append("token", sessionStorage.B.encodeDecode());
                            data.append("path", templateId + '.wav');
                            return fetch(configAPI.api.prod + 'UploadFile', {
                                method: "POST",
                                body: data
                            })
                                .then((resp) => {
                                    if (resp.ok) {
                                        const request = new Request(configAPI.api.prod + 'RunCampaign?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + templateId + '&phones=' + receiver)
                                        return fetch(request)
                                            .then(resp => { return resp.json(); })
                                            .then(responseRun => {
                                                console.log(responseRun);
                                                if (responseRun.responseStatus === 'OK') {
                                                    this.setState({
                                                        blocked: responseRun.blocked, pending: responseRun.pending, customerUnits: responseRun.customerUnits,
                                                        estimatedPrice: responseRun.estimatedPrice, entriesCount: responseRun.entriesCount
                                                    })
                                                    const request = new Request(configAPI.api.prod + 'DeleteTemplate?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + templateId)
                                                    return fetch(request)
                                                        .then(responseDelete => {
                                                            console.log(responseDelete);
                                                        })
                                                }
                                            })
                                    }
                                })
                                .catch((e) => {
                                    console.log(e);
                                });
                        } case 'R': {
                            data.append("upload", this.state.newRecording);
                            data.append("token", sessionStorage.B.encodeDecode());
                            data.append("path", templateId + '.wav');
                            return fetch(configAPI.api.prod + 'UploadFile', {
                                method: "POST",
                                body: data
                            })
                                .then((resp) => {
                                    if (resp.ok) {
                                        const request = new Request(configAPI.api.prod + 'RunCampaign?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + templateId + '&phones=' + receiver)
                                        return fetch(request)
                                            .then(resp => { return resp.json(); })
                                            .then(responseRun => {
                                                console.log(responseRun);
                                                if (responseRun.responseStatus === 'OK') {
                                                    this.setState({
                                                        blocked: responseRun.blocked, pending: responseRun.pending, customerUnits: responseRun.customerUnits,
                                                        estimatedPrice: responseRun.estimatedPrice, entriesCount: responseRun.entriesCount
                                                    })
                                                    const request = new Request(configAPI.api.prod + 'DeleteTemplate?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + templateId)
                                                    return fetch(request)
                                                        .then(responseDelete => {
                                                            console.log(responseDelete);
                                                        })
                                                }
                                            })
                                    }
                                })
                                .catch((e) => {
                                    console.log(e);
                                });
                        } default: { }
                    }
                });
        } else if (messageType === 'D') {
            const request = new Request(configAPI.api.prod + 'GetTemplates?token=' + sessionStorage.B.encodeDecode())
            return fetch(request)
                .then(resp => { return resp.json(); })
                .then(responseGet => {
                    console.log(responseGet);
                    if (responseGet.responseStatus === 'OK') {
                        let defaultTpl = 0;
                        responseGet.templates.forEach(tpl => {
                            if (tpl.customerDefault) {
                                defaultTpl = tpl.templateId;

                                const request = new Request(configAPI.api.prod + 'RunCampaign?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + defaultTpl + '&phones=' + receiver)
                                return fetch(request)
                                    .then(resp => { return resp.json(); })
                                    .then(responseRun => {
                                        console.log(responseRun);
                                        if (responseRun.responseStatus === 'OK') {
                                            this.setState({
                                                blocked: responseRun.blocked, pending: responseRun.pending, customerUnits: responseRun.customerUnits,
                                                estimatedPrice: responseRun.estimatedPrice, entriesCount: responseRun.entriesCount
                                            })
                                        }
                                    })
                            }
                        });
                    }
                })
        }

    }
    render() {
        const {
            blocked = 0, pending = 0, customerUnits = 0, estimatedPrice = 0, entriesCount = 0
        } = this.state;
        const { translate } = this.props;
        return (
            <div style={{ float: "right" }}>
                <Button
                    primary
                    label={translate(`resources.Templates.quick_send`)}
                    onClick={this.handleClickOpen}
                ><Sms color="primary" /><label style={{ color: 'darkblue', cursor: "pointer" }}>{translate(`resources.templates.quick_send`)}</label></Button>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <IconButton color="inherit" onClick={(e) => this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
                        <CloseIcon />
                    </IconButton>
                    <SimpleForm
                        toolbar={false}
                        defaultValue={{ average_note: 0 }}
                    >
                        <SelectInput source="message_type" label={translate(`resources.templates.message_type`)} choices={[
                            { id: 'DEFAULT', name: translate(`resources.templates.default`) },
                            { id: 'TTS', name: translate(`resources.templates.tts`) },
                            { id: 'SMS', name: translate(`resources.templates.sms`) },
                            { id: 'AUDIO', name: translate(`resources.templates.audio`) },
                            { id: 'RECORDING', name: translate(`resources.templates.recording`) }
                        ]} onChange={this.handleMessageTypeChange} />
                        <FormDataConsumer>
                            {({ formData, ...rest }) => (formData.message_type === "TTS") &&
                                <>
                                    <TextInput fullWidth source="phone" onChange={this.handleReceiverChange} label={translate(`resources.templates.phonePlus`)} />
                                    <br />
                                    <TextInput source="message" options={{ multiLine: true }} onChange={this.handleMessageChange} {...rest} label={translate(`resources.templates.message`)} />
                                </>
                            }
                        </FormDataConsumer>
                        <FormDataConsumer>
                            {({ formData, ...rest }) => (formData.message_type === "SMS") &&
                                <>
                                    <TextInput fullWidth source="phone" onChange={this.handleReceiverChange} label={translate(`resources.templates.phonePlus`)} />
                                    <Typography>TTS {translate(`resources.templates.smsWarning`)}</Typography>
                                    <TextInput source="message" options={{ multiLine: true }} onChange={this.handleMessageChange} {...rest} label={translate(`resources.templates.message`)} />
                                </>
                            }
                        </FormDataConsumer>
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData.message_type === "AUDIO" &&
                                <>
                                    <TextInput fullWidth source="phone" onChange={this.handleReceiverChange} label={translate(`resources.templates.phonePlus`)} />
                                    <DropzoneComponent onDrop={this.onDrop} />
                                </>
                            }
                        </FormDataConsumer>
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData.message_type === "DEFAULT" &&
                                <>
                                    <TextInput fullWidth source="phone" onChange={this.handleReceiverChange} label={translate(`resources.templates.phonePlus`)} />
                                </>
                            }
                        </FormDataConsumer>
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData.message_type === "RECORDING" &&
                                <div>
                                    <TextInput fullWidth source="phone" onChange={this.handleReceiverChange} label={translate(`resources.templates.phone`)} />
                                    <ReactMic
                                        record={this.state.record}
                                        className="sound-wave"
                                        onStop={this.onStop}
                                        onData={this.onData}
                                    />
                                    <Button
                                        onClick={this.startRecording}>
                                        <MicrophoneOn />
                                    </Button>
                                    <Button
                                        onClick={this.stopRecording}>
                                        <MicrophoneOff />
                                    </Button>
                                </div>
                            }
                        </FormDataConsumer>
                    </SimpleForm>
                    <Paper style={{ margin: 10 }}>
                        <div style={{ textAlign: 'right' }}>
                            {translate(`resources.templates.blocked`)} : {blocked} <br />
                            {translate(`resources.templates.pending`)}: {pending} <br />
                            {translate(`resources.templates.customer_units`)} : {customerUnits} <br />
                            {translate(`resources.templates.estimated_price`)}: {estimatedPrice} <br />
                            {translate(`resources.templates.entries_called`)}: {entriesCount}
                            <br />
                        </div>
                    </Paper>
                    <DialogActions>
                        <Button onClick={this.handleSendSubmit} color="primary">
                            {translate('ra.action.ok')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default translate(QuickSendButton);
